(function () {
  'use strict';

  var STORAGE_CLOSED   = 'hoa_nl_popup_closed';
  var STORAGE_SUBBED   = 'hoa_nl_popup_subscribed';
  var CLOSE_TTL_DAYS   = 7;
  var TRIGGER_DELAY_MS = 30000;

  function shouldShow() {
    try {
      var subbed = localStorage.getItem(STORAGE_SUBBED);
      if (subbed === '1') return false;

      var closedAt = parseInt(localStorage.getItem(STORAGE_CLOSED) || '0', 10);
      if (closedAt) {
        var daysSince = (Date.now() - closedAt) / (1000 * 60 * 60 * 24);
        if (daysSince < CLOSE_TTL_DAYS) return false;
      }
    } catch (e) { /* localStorage blocked */ }
    return true;
  }

  function markClosed() {
    try { localStorage.setItem(STORAGE_CLOSED, String(Date.now())); } catch (e) {}
  }

  function markSubscribed() {
    try { localStorage.setItem(STORAGE_SUBBED, '1'); } catch (e) {}
  }

  function openPopup(backdrop) {
    backdrop.classList.add('hoa-nl-popup--visible');
    backdrop.removeAttribute('hidden');
    backdrop.setAttribute('aria-hidden', 'false');

    // Focus the close button for a11y
    var closeBtn = backdrop.querySelector('.hoa-nl-popup__close');
    if (closeBtn) setTimeout(function () { closeBtn.focus(); }, 350);
  }

  function closePopup(backdrop) {
    backdrop.classList.remove('hoa-nl-popup--visible');
    backdrop.setAttribute('aria-hidden', 'true');
    setTimeout(function () { backdrop.setAttribute('hidden', ''); }, 350);
    markClosed();
  }

  function initFocusTrap(modal, backdrop) {
    var focusable = 'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])';

    modal.addEventListener('keydown', function (e) {
      if (e.key !== 'Tab') return;
      var els = Array.from(modal.querySelectorAll(focusable)).filter(function (el) {
        return !el.disabled && el.offsetParent !== null;
      });
      if (!els.length) return;

      var first = els[0];
      var last  = els[els.length - 1];

      if (e.shiftKey) {
        if (document.activeElement === first) { e.preventDefault(); last.focus(); }
      } else {
        if (document.activeElement === last) { e.preventDefault(); first.focus(); }
      }
    });

    // Escape closes
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && backdrop.classList.contains('hoa-nl-popup--visible')) {
        closePopup(backdrop);
      }
    });
  }

  function initPopup() {
    var backdrop = document.getElementById('hoa-nl-popup');
    if (!backdrop || !shouldShow()) return;

    var modal    = backdrop.querySelector('.hoa-nl-popup__modal');
    var closeBtn = backdrop.querySelector('.hoa-nl-popup__close');
    var form     = backdrop.querySelector('.hoa-nl-popup__form');
    var emailInput = backdrop.querySelector('.hoa-nl-popup__input');
    var submitBtn  = backdrop.querySelector('.hoa-nl-popup__submit');

    // Close on backdrop click
    backdrop.addEventListener('click', function (e) {
      if (e.target === backdrop) closePopup(backdrop);
    });

    // Close button
    if (closeBtn) {
      closeBtn.addEventListener('click', function () { closePopup(backdrop); });
    }

    // Form submit
    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var email = emailInput ? emailInput.value.trim() : '';
        if (!email) return;

        if (submitBtn) {
          submitBtn.disabled = true;
          submitBtn.textContent = '...';
        }

        // Shopify newsletter subscribe via Customer API
        fetch('/contact', {
          method: 'POST',
          headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
          body: 'form_type=customer&utf8=✓&contact[email]=' + encodeURIComponent(email) + '&contact[tags]=newsletter'
        }).finally(function () {
          markSubscribed();
          backdrop.classList.add('hoa-nl-popup--subscribed');
          setTimeout(function () { closePopup(backdrop); }, 3500);
        });
      });
    }

    initFocusTrap(modal, backdrop);

    // ── Trigger: 30s delay
    var delayTimer = setTimeout(function () {
      openPopup(backdrop);
    }, TRIGGER_DELAY_MS);

    // ── Trigger: Exit-intent (mouse leaves viewport upward)
    function onMouseOut(e) {
      if (e.clientY <= 0 && !backdrop.classList.contains('hoa-nl-popup--visible')) {
        clearTimeout(delayTimer);
        openPopup(backdrop);
        document.removeEventListener('mouseout', onMouseOut);
      }
    }
    document.addEventListener('mouseout', onMouseOut);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initPopup);
  } else {
    initPopup();
  }
})();
